import { inject, Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { LoadingService } from '@portal/loading/data-access';
import { ApplicationApiService } from '../api/application-api.service';
import { ROUTE } from '../constant/route.constant';
import { catchError, finalize, switchMap, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LoanQuoteResponse } from '../type/loan-quote.type';

@Injectable({ providedIn: 'root' })
export class ReviewLoanResolver implements Resolve<LoanQuoteResponse> {
  private readonly applicationApi = inject(ApplicationApiService);
  private readonly loadingService = inject(LoadingService);
  private readonly router = inject(Router);

  resolve() {
    this.loadingService.show();

    const checkCbs$ = this.applicationApi.checkCbs().pipe(
      catchError((error: HttpErrorResponse) => {
        const code = error?.error?.errorCode;
        switch (code) {
          case 'BIZ002':
          case 'BIZ015':
            this.router.navigate([ROUTE.ERROR.MAIN, ROUTE.ERROR.NOT_ACCEPTABLE].filter(Boolean));
            break;
          default:
            this.navigateToUnderReview();
            break;
        }

        return throwError(() => error);
      }),
    );

    const getQuote$ = this.applicationApi.getLoanQuote().pipe(
      catchError((error: HttpErrorResponse) => {
        this.navigateToUnderReview();
        return throwError(() => error);
      }),
    );

    return checkCbs$.pipe(
      switchMap(() => getQuote$),
      finalize(() => this.loadingService.hide()),
    );
  }

  private navigateToUnderReview(): void {
    this.router.navigate([ROUTE.SUCCESS.MAIN, ROUTE.SUCCESS.UNDER_REVIEW]);
  }
}
